import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BellTwoToneSvg from "@ant-design/icons-svg/es/asn/BellTwoTone";
import AntdIcon from "../components/AntdIcon";
var BellTwoTone = function BellTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BellTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BellTwoTone.displayName = 'BellTwoTone';
}
export default /*#__PURE__*/React.forwardRef(BellTwoTone);